<payee-popup
  [onCancel]="cancel"
  [onSubmit]="submit"
>
  <ng-template #payeePopupTitleTemplate>
    <h1>MOKK cookie beállítása</h1>
  </ng-template>

  <div class="set-mokk-cookie-form">
    <p class="law-firm-name">{{ data.name }}</p>

    @if (data.has_mokk_cookie) {
      <p class="cookie-status">Jelenleg be van állítva MOKK cookie.</p>
    } @else {
      <p class="cookie-status">Nincs beállítva MOKK cookie.</p>
    }

    <payee-form-field
      width="max"
      height="tallest"
    >
      <span payee-label>JSESSIONID</span>
      <input
        payee-input
        placeholder="Illeszd be a MOKK JSESSIONID értékét"
        [formControl]="mokkCookie"
      />
    </payee-form-field>

    <p class="hint">Üresen hagyva törli a mentett cookie-t.</p>
  </div>
</payee-popup>
